import AccountTreeIcon from "@mui/icons-material/AccountTree";

interface DashboardIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function AccountTreeIconConfigurable({
  htmlColor,
  fontSize,
}: DashboardIconProps) {
  return <AccountTreeIcon htmlColor={htmlColor || "currentColor"} />;
}
